module.exports = function() {
  return new Worker(__webpack_public_path__ + "cf1fa8f80277ece67864.worker.js");
};